export function currencyFormat(price, sign = "") {
  const pieces = parseFloat(price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  return sign + pieces.split('.')[0];
}
